import { CareText } from "../../ui/text/CareText/CareText";
import { CareContentWrap } from "../../ui/wrappers/CareContentWrap/CareContentWrap";

export const CareMain = () => {
  return (
    <CareContentWrap>
      <title>Как ухаживать за вещами MIYUKON</title>
      <meta
        name="description"
        content="Инструкции по уходу без канцелярщины. Чтобы ткань дышала, принт не тускнел, а вещь жила дольше."
      />
      <meta property="og:title" content="Как ухаживать за вещами MIYUKON" />
      <meta
        property="og:description"
        content="Стирайте, сушите и храните с заботой — и вещь будет жить дольше."
      />
      <meta property="og:url" content="https://miyukon.ru/care" />
      {/*<meta property="og:image" content="https://miyukon.ru/path-to-your-og-image.jpg" />*/}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="MIYUKON" />
      <CareText>
        <span style={{ fontWeight: 600 }}>
          Одежда, как и воспоминания, требует бережного отношения.
        </span>
      </CareText>
      <CareText>
        В каждой коллекции MIYUKON мы используем разные материалы и отделку — и
        к каждой вещи подходим внимательно.
      </CareText>
      <CareText>
        Здесь вы найдёте рекомендации по стирке, сушке, глажке и хранению — с
        учётом особенностей ткани, кроя и замысла.
      </CareText>
      <CareText>
        <span style={{ fontWeight: 600 }}>Просто выберите коллекцию,</span>{" "}
        чтобы узнать, как сохранить форму, цвет и комфорт надолго. Пусть эти
        вещи остаются с вами так же легко, как в день, когда вы их примерили
        впервые.
      </CareText>
    </CareContentWrap>
  );
};
